// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────
   Engineer.css — redesigned styles
───────────────────────────────────────────── */

.eng-page {
  /* padding: 2rem; */
  /* max-width: 960px; */
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #1a1a1a;
}

/* ── TOP BAR ── */
.eng-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.75rem;
}
.eng-page-title {
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.3px;
  margin: 0 0 2px;
}
.eng-page-sub {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
}

/* ── BUTTONS ── */
.eng-btn-primary {
  background: #185fa5;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 9px 20px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}
.eng-btn-primary:hover { background: #0c447c; }
.eng-btn-primary:disabled { background: #93b8d8; cursor: not-allowed; }

.eng-btn-ghost {
  background: transparent;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 9px 20px;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s;
}
.eng-btn-ghost:hover { background: #f3f4f6; }
.eng-btn-sm { padding: 6px 14px; font-size: 12px; }

/* ── STAT CARDS ── */
.eng-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 1.75rem;
}
.eng-stat-card {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 1rem 1.25rem;
}
.eng-stat-label {
  font-size: 12px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}
.eng-stat-value {
  font-size: 28px;
  font-weight: 600;
  color: #111827;
}
.eng-stat-green { color: #3b6d11; }

/* ── TABLE CARD ── */
.eng-table-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}
.eng-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e5e7eb;
}
.eng-table-title {
  font-size: 15px;
  font-weight: 600;
}
.eng-search {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 7px 12px;
  font-size: 13px;
  background: #f9fafb;
  color: #111827;
  width: 220px;
  outline: none;
  transition: border-color 0.15s;
}
.eng-search:focus { border-color: #185fa5; }

.eng-table {
  width: 100%;
  border-collapse: collapse;
}
.eng-table th {
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 10px 1.25rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}
.eng-table td {
  padding: 13px 1.25rem;
  font-size: 13.5px;
  border-bottom: 1px solid #f3f4f6;
  color: #111827;
}
.eng-table tbody tr:last-child td { border-bottom: none; }
.eng-table tbody tr:hover td { background: #f9fafb; }

.eng-muted { color: #6b7280 !important; }

.eng-name-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}
.eng-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #dbeafe;
  color: #185fa5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.eng-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;
}
.eng-badge-active  { background: #d1fae5; color: #065f46; }
.eng-badge-inactive { background: #f3f4f6; color: #6b7280; }

.eng-empty {
  text-align: center;
  padding: 3rem;
  font-size: 14px;
  color: #6b7280;
}

/* ── DRAWER OVERLAY ── */
.eng-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
}
.eng-drawer {
  width: 500px;
  height: 100%;
  background: #fff;
  overflow-y: auto;
  padding: 1.75rem;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.1);
}
.eng-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}
.eng-drawer-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}
.eng-close-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  background: transparent;
  cursor: pointer;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  transition: background 0.15s;
}
.eng-close-btn:hover { background: #f3f4f6; }

/* ── FORM ── */
.eng-section-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #6b7280;
  margin: 1.25rem 0 0.75rem;
  padding-bottom: 6px;
  border-bottom: 1px solid #e5e7eb;
}
.eng-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
}
.eng-form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 12px;
}
.eng-form-group label {
  font-size: 12px;
  font-weight: 500;
  color: #374151;
}
.eng-form-group input {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 11px;
  font-size: 13px;
  background: #f9fafb;
  color: #111827;
  outline: none;
  width: 100%;
  transition: border-color 0.15s;
}
.eng-form-group input:focus { border-color: #185fa5; background: #fff; }

.eng-file-upload {
  display: block;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  padding: 12px;
  text-align: center;
  cursor: pointer;
  font-size: 12px;
  color: #6b7280;
  background: #f9fafb;
  transition: all 0.15s;
  word-break: break-all;
}
.eng-file-upload:hover { border-color: #185fa5; color: #185fa5; background: #eff6ff; }

.eng-form-actions {
  display: flex;
  gap: 10px;
  margin-top: 1.75rem;
  padding-top: 1.25rem;
  border-top: 1px solid #e5e7eb;
}

/* ── RESPONSIVE ── */
@media (max-width: 640px) {
  .eng-page { padding: 1rem; }
  .eng-stats { grid-template-columns: 1fr; }
  .eng-form-row { grid-template-columns: 1fr; }
  .eng-drawer { width: 100%; }
  .eng-table th:nth-child(4),
  .eng-table td:nth-child(4) { display: none; }
}

/* ── ACTION BUTTONS ── */
.eng-action-btns {
  display: flex;
  gap: 6px;
  align-items: center;
}
.eng-btn-status {
  background: transparent;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 6px 14px;
  font-size: 12px;
  color: #185fa5;
  border-color: #bfdbfe;
  cursor: pointer;
  transition: all 0.15s;
  font-weight: 500;
}
.eng-btn-status:hover {
  background: #eff6ff;
  border-color: #93c5fd;
}

/* ── STATUS MODAL ── */
.eng-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.eng-modal {
  background: #fff;
  border-radius: 14px;
  padding: 1.5rem;
  width: 340px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}
.eng-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.eng-modal-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}
.eng-modal-name {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 1.25rem;
}
.eng-status-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 1.25rem;
}
.eng-status-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
}
.eng-status-option:hover {
  background: #f9fafb;
  border-color: #d1d5db;
}
.eng-status-option.selected {
  border-color: #185fa5;
  background: #eff6ff;
}
.eng-status-option input[type="radio"] {
  accent-color: #185fa5;
  width: 15px;
  height: 15px;
  flex-shrink: 0;
}
.eng-modal-actions {
  display: flex;
  gap: 10px;
}


/* Wrapper */
.eng-filter-wrapper {
  position: relative;
  display: inline-block;
  min-width: 220px;
}

/* Select box */
.eng-status-filter {
  width: 100%;
  padding: 10px 40px 10px 14px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  appearance: none;
  cursor: pointer;
  transition: all 0.25s ease;
}

/* Hover */
.eng-status-filter:hover {
  border-color: #6366f1;
}

/* Focus */
.eng-status-filter:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

/* Dropdown icon */
.eng-filter-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: #6b7280;
  pointer-events: none;
}

/* Optional: subtle shadow for premium feel */
.eng-filter-wrapper:hover .eng-status-filter {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
/* Right alignment container */
.eng-actions-right {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-bottom: 16px;
}

/* Base button */
.eng-btn {
  padding: 10px 18px;
  border-radius: 10px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.25s ease;
}

/* Payment button (Blue) */
.eng-btn-payment {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
}

.eng-btn-payment:hover {
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.3);
  transform: translateY(-1px);
}

/* Attendance button (Green) */
.eng-btn-attendance {
  background: linear-gradient(135deg, #10b981, #059669);
}

.eng-btn-attendance:hover {
  box-shadow: 0 6px 16px rgba(5, 150, 105, 0.3);
  transform: translateY(-1px);
}

/* Click effect */
.eng-btn:active {
  transform: scale(0.97);
}`, "",{"version":3,"sources":["webpack://./src/Pages/Registration/Engineer.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,sEAAsE;EACtE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,yBAAyB,mBAAmB,EAAE;AAC9C,4BAA4B,mBAAmB,EAAE,mBAAmB,EAAE;;AAEtE;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA,uBAAuB,mBAAmB,EAAE;AAC5C,cAAc,iBAAiB,EAAE,eAAe,EAAE;;AAElD,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,kBAAkB,cAAc,EAAE;;AAElC,qBAAqB;AACrB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;AACA,oBAAoB,qBAAqB,EAAE;;AAE3C;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;AACA,oCAAoC,mBAAmB,EAAE;AACzD,+BAA+B,mBAAmB,EAAE;;AAEpD,aAAa,yBAAyB,EAAE;;AAExC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;;AAE3D;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4BAA4B;AAC9B;AACA,uBAAuB,mBAAmB,EAAE;;AAE5C,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;AACA,8BAA8B,qBAAqB,EAAE,gBAAgB,EAAE;;AAEvE;EACE,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;AACA,yBAAyB,qBAAqB,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAErF;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA,qBAAqB;AACrB;EACE,YAAY,aAAa,EAAE;EAC3B,aAAa,0BAA0B,EAAE;EACzC,gBAAgB,0BAA0B,EAAE;EAC5C,cAAc,WAAW,EAAE;EAC3B;+BAC6B,aAAa,EAAE;AAC9C;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;AACX;;;AAGA,YAAY;AACZ;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA,6CAA6C;AAC7C;EACE,0CAA0C;AAC5C;AACA,8BAA8B;AAC9B;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,qDAAqD;AACvD;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,qDAAqD;AACvD;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;AACxB","sourcesContent":["/* ─────────────────────────────────────────────\n   Engineer.css — redesigned styles\n───────────────────────────────────────────── */\n\n.eng-page {\n  /* padding: 2rem; */\n  /* max-width: 960px; */\n  margin: 0 auto;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  color: #1a1a1a;\n}\n\n/* ── TOP BAR ── */\n.eng-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.75rem;\n}\n.eng-page-title {\n  font-size: 22px;\n  font-weight: 600;\n  letter-spacing: -0.3px;\n  margin: 0 0 2px;\n}\n.eng-page-sub {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 0;\n}\n\n/* ── BUTTONS ── */\n.eng-btn-primary {\n  background: #185fa5;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 9px 20px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.eng-btn-primary:hover { background: #0c447c; }\n.eng-btn-primary:disabled { background: #93b8d8; cursor: not-allowed; }\n\n.eng-btn-ghost {\n  background: transparent;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 9px 20px;\n  font-size: 13px;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.eng-btn-ghost:hover { background: #f3f4f6; }\n.eng-btn-sm { padding: 6px 14px; font-size: 12px; }\n\n/* ── STAT CARDS ── */\n.eng-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  margin-bottom: 1.75rem;\n}\n.eng-stat-card {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 1rem 1.25rem;\n}\n.eng-stat-label {\n  font-size: 12px;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 6px;\n}\n.eng-stat-value {\n  font-size: 28px;\n  font-weight: 600;\n  color: #111827;\n}\n.eng-stat-green { color: #3b6d11; }\n\n/* ── TABLE CARD ── */\n.eng-table-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n}\n.eng-table-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n.eng-table-title {\n  font-size: 15px;\n  font-weight: 600;\n}\n.eng-search {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 7px 12px;\n  font-size: 13px;\n  background: #f9fafb;\n  color: #111827;\n  width: 220px;\n  outline: none;\n  transition: border-color 0.15s;\n}\n.eng-search:focus { border-color: #185fa5; }\n\n.eng-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.eng-table th {\n  text-align: left;\n  font-size: 11px;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 10px 1.25rem;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n.eng-table td {\n  padding: 13px 1.25rem;\n  font-size: 13.5px;\n  border-bottom: 1px solid #f3f4f6;\n  color: #111827;\n}\n.eng-table tbody tr:last-child td { border-bottom: none; }\n.eng-table tbody tr:hover td { background: #f9fafb; }\n\n.eng-muted { color: #6b7280 !important; }\n\n.eng-name-cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.eng-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: #dbeafe;\n  color: #185fa5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.eng-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 500;\n}\n.eng-badge-active  { background: #d1fae5; color: #065f46; }\n.eng-badge-inactive { background: #f3f4f6; color: #6b7280; }\n\n.eng-empty {\n  text-align: center;\n  padding: 3rem;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n/* ── DRAWER OVERLAY ── */\n.eng-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  display: flex;\n  justify-content: flex-end;\n}\n.eng-drawer {\n  width: 500px;\n  height: 100%;\n  background: #fff;\n  overflow-y: auto;\n  padding: 1.75rem;\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.1);\n}\n.eng-drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n}\n.eng-drawer-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n}\n.eng-close-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid #e5e7eb;\n  background: transparent;\n  cursor: pointer;\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n  transition: background 0.15s;\n}\n.eng-close-btn:hover { background: #f3f4f6; }\n\n/* ── FORM ── */\n.eng-section-label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: #6b7280;\n  margin: 1.25rem 0 0.75rem;\n  padding-bottom: 6px;\n  border-bottom: 1px solid #e5e7eb;\n}\n.eng-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n.eng-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-bottom: 12px;\n}\n.eng-form-group label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #374151;\n}\n.eng-form-group input {\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 8px 11px;\n  font-size: 13px;\n  background: #f9fafb;\n  color: #111827;\n  outline: none;\n  width: 100%;\n  transition: border-color 0.15s;\n}\n.eng-form-group input:focus { border-color: #185fa5; background: #fff; }\n\n.eng-file-upload {\n  display: block;\n  border: 1px dashed #d1d5db;\n  border-radius: 8px;\n  padding: 12px;\n  text-align: center;\n  cursor: pointer;\n  font-size: 12px;\n  color: #6b7280;\n  background: #f9fafb;\n  transition: all 0.15s;\n  word-break: break-all;\n}\n.eng-file-upload:hover { border-color: #185fa5; color: #185fa5; background: #eff6ff; }\n\n.eng-form-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 1.75rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n/* ── RESPONSIVE ── */\n@media (max-width: 640px) {\n  .eng-page { padding: 1rem; }\n  .eng-stats { grid-template-columns: 1fr; }\n  .eng-form-row { grid-template-columns: 1fr; }\n  .eng-drawer { width: 100%; }\n  .eng-table th:nth-child(4),\n  .eng-table td:nth-child(4) { display: none; }\n}\n\n/* ── ACTION BUTTONS ── */\n.eng-action-btns {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n.eng-btn-status {\n  background: transparent;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 6px 14px;\n  font-size: 12px;\n  color: #185fa5;\n  border-color: #bfdbfe;\n  cursor: pointer;\n  transition: all 0.15s;\n  font-weight: 500;\n}\n.eng-btn-status:hover {\n  background: #eff6ff;\n  border-color: #93c5fd;\n}\n\n/* ── STATUS MODAL ── */\n.eng-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.eng-modal {\n  background: #fff;\n  border-radius: 14px;\n  padding: 1.5rem;\n  width: 340px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n}\n.eng-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n}\n.eng-modal-title {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n}\n.eng-modal-name {\n  font-size: 13px;\n  color: #6b7280;\n  margin-bottom: 1.25rem;\n}\n.eng-status-options {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 1.25rem;\n}\n.eng-status-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.eng-status-option:hover {\n  background: #f9fafb;\n  border-color: #d1d5db;\n}\n.eng-status-option.selected {\n  border-color: #185fa5;\n  background: #eff6ff;\n}\n.eng-status-option input[type=\"radio\"] {\n  accent-color: #185fa5;\n  width: 15px;\n  height: 15px;\n  flex-shrink: 0;\n}\n.eng-modal-actions {\n  display: flex;\n  gap: 10px;\n}\n\n\n/* Wrapper */\n.eng-filter-wrapper {\n  position: relative;\n  display: inline-block;\n  min-width: 220px;\n}\n\n/* Select box */\n.eng-status-filter {\n  width: 100%;\n  padding: 10px 40px 10px 14px;\n  border-radius: 10px;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n  appearance: none;\n  cursor: pointer;\n  transition: all 0.25s ease;\n}\n\n/* Hover */\n.eng-status-filter:hover {\n  border-color: #6366f1;\n}\n\n/* Focus */\n.eng-status-filter:focus {\n  outline: none;\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);\n}\n\n/* Dropdown icon */\n.eng-filter-icon {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 14px;\n  color: #6b7280;\n  pointer-events: none;\n}\n\n/* Optional: subtle shadow for premium feel */\n.eng-filter-wrapper:hover .eng-status-filter {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n/* Right alignment container */\n.eng-actions-right {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n/* Base button */\n.eng-btn {\n  padding: 10px 18px;\n  border-radius: 10px;\n  border: none;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.25s ease;\n}\n\n/* Payment button (Blue) */\n.eng-btn-payment {\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n}\n\n.eng-btn-payment:hover {\n  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.3);\n  transform: translateY(-1px);\n}\n\n/* Attendance button (Green) */\n.eng-btn-attendance {\n  background: linear-gradient(135deg, #10b981, #059669);\n}\n\n.eng-btn-attendance:hover {\n  box-shadow: 0 6px 16px rgba(5, 150, 105, 0.3);\n  transform: translateY(-1px);\n}\n\n/* Click effect */\n.eng-btn:active {\n  transform: scale(0.97);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
